import VueSlickCarousel from "vue-slick-carousel";
import { mapGetters } from "vuex";
import { Carousel, Slide } from "vue-carousel";
import product from "@/components/product";

export default {
  name: "PigmentCodeSlider",
  props: {},
  emits: [],
  components: {
    product,
    VueSlickCarousel,
    Carousel,
    Slide,
  },
  setup() {},
  data() {
    return {
      panels: [1, 2, 3],
    };
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters({
      content: "pigmentCode/content",
    }),
    slideCount() {
      return window.innerWidth < 768 ? 1 : 3;
    },
  },
  methods: {},
};
